import React from "react";
import "./LoadingOverlay.scss";

interface LoadingOverlayProps {
  isLoading: boolean;
  loadingText?: string;
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ isLoading, loadingText }) => {
  if (!isLoading) return null;

  return (
    <div className="loading-overlay">
      <div className="loader"></div>
      <span className="loading-text">{ loadingText || 'Processing, please wait...' }</span>
    </div>
  );
};

export default LoadingOverlay;